import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { SidebarFooterProps } from './types';

export function SidebarFooter({ isCollapsed }: SidebarFooterProps) {
  const { t } = useTranslation('layout');
  return (
    <div
      className={cn(
        'p-4 border-t border-blue-800 bg-blue-950/30 transition-all duration-300',
        isCollapsed ? 'items-center' : 'items-start',
      )}
    >
      {!isCollapsed ? (
        <div className="space-y-3">
          <div className="flex items-center gap-2 bg-white rounded-md p-2">
            <img src="/logo.png" alt="Someaknea Tech" className="h-10 w-auto" />
            <span className="text-[10px] font-bold tracking-widest text-blue-400 uppercase">
              v0.0.1 Beta
            </span>
          </div>

          <div className="space-y-1">
            <p className="text-[11px] text-blue-200/60 leading-tight">
              © 2025 <span className="text-white font-medium">All rights reserved.</span>.
            </p>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-2">
          <img src="/logo-m.png" className="h-10 w-auto" alt="Logo" />
          <span className="text-[8px] font-bold text-blue-400">v0.0.1 BETA</span>
        </div>
      )}
    </div>
  );
}
